<template>
    <div>
        <!-- <router-view/> -->
        <div class="bgimg">
        <el-form :model="loginform" :rules="reles2" ref="loginform" class="demo-ruleForm login-container" label-position="right" label-width="0px" >
            <h2 class="title" style="color:#2f84ac;"><img style="vertical-align: bottom;" src="../assets/user_login2.png" alt=""> Login</h2>
            <span>Account:</span> 
            <el-form-item prop='account'>
                <el-input type="text" v-model="loginform.account" placeholder="Account"></el-input>
            </el-form-item>
            <span>Password:</span> 
            <el-form-item prop='checkPass' style="margin:0;">
                <el-input type="password" v-model="loginform.checkPass" placeholder="Password"></el-input>
            </el-form-item>
            <el-form-item>
                <router-link class="fr" style="color: #2f84ac;" to="/user/forgetpassword">Forgot your password?</router-link>
            </el-form-item>
            <el-form-item style="width:50%;margin:auto;">
            <el-button class="el-button--primary" type="primary" style="width:100%;" @click.native.prevent="handleSubmit2" @keyup.enter.native="handleSubmit2()">
                Sign In
            </el-button>
            </el-form-item>
            <!-- <div style="text-align:center;margin-top:15px;">New custome?
                <router-link style="color: #2f84ac;" to="/">Register Now</router-link>
            </div> -->
        </el-form>
        </div>
    </div>
</template>

<script>
import md5 from 'js-md5'
import {requestLogin, GetUserInfo ,phoneCodeLogin} from '../api/api';
export default {
    data(){
        return{
            loginform:{
                account:'',
                checkPass:''
            },
            reles2:{
                account: [{
                    required: true,
                    // message: "请输入账号",
                    message: "Please enter the account number",
                    trigger: "blur"
                    }
                ],
                checkPass: [{
                    required: true,
                    // message: "请输入密码",
                    message: "Please input your password",
                    trigger: "blur"
                    }
                ],
            }
        }
    },
    methods:{
        //获取用户信息
        getuserInfo(onereg,token){
            GetUserInfo({token: token}).then(res=>{
                console.log(res);
                localStorage.setItem('patient_info',JSON.stringify(res.data.patient_info))
                if(onereg === '1'){
                    this.$router.push('/user/member')
                }else{
                    // this.$router.push({name:'homeindex',params:{patientInfo:res.data.patient_info}})
                    this.$router.push('/home/index')
                }
            })
        },
        handleSubmit2(ev){       
            this.$refs.loginform.validate( valid => {
            if (valid) {
                // let para = {
                //     mobile: this.loginform.account,
                //     captcha: this.loginform.checkPass,
                //     event: 'login'
                // }
                // phoneCodeLogin(para).then(res => {
                //     console.log(res)    
                //     let {
                //         code,
                //         data,
                //         msg
                //     } = res;
                //     console.log(code)
                //     console.log(data)
                //     console.log(msg)
                //     if(code == '5104' || code == '5106' || code == '5105'){
                //         this.$message({
                //             message:msg,
                //             type:'warning'
                //         });
                //     }else{
                //         localStorage.setItem("key", JSON.stringify(data.userinfo.token));
                //         sessionStorage.setItem("user", JSON.stringify(data)); 
                //         this.getuserInfo(data.userinfo.token)
                //         this.$emit('fatherMethod',res.data.userinfo.user_nickname)
                //         // this.$emit('gettoken',data.userinfo.token)
                //         if(data.userinfo.onereg === '1'){
                //             this.$router.push('/user/member')
                //         }else{
                //             this.$router.push('/home/index')
                //         }
                        
                //     }
                // })
                let loginParams = {
                    account: this.loginform.account,
                    password: md5(this.loginform.checkPass)
                }
                requestLogin(loginParams).then(res => {
                    console.log(res)    
                    let {
                        code,
                        data,
                        msg
                    } = res;
                    console.log(code)
                    console.log(data)
                    console.log(msg)
                    if(code == '5104' || code == '5106' || code == '5105'){
                        this.$message({
                            message:msg,
                            type:'warning'
                        });
                    }else{
                        localStorage.setItem("key", JSON.stringify(data.userinfo.token));
                        sessionStorage.setItem("user", JSON.stringify(data)); 
                        this.$emit('fatherMethod',res.data.userinfo.user_nickname)
                        this.getuserInfo(data.userinfo.onereg,data.userinfo.token)

                        // this.$emit('gettoken',data.userinfo.token)
                        // if(data.userinfo.onereg === '1'){
                        //     this.$router.push('/user/member')
                        // }else{
                        //     // this.$router.push({path:'/home/index',query:{name:'xxx'}})
                        //     this.$router.push({name:'homeindex',params:{patientInfo:'xxx'}})
                        // }
                        
                    }
                })
            } else {
                console.log('error submit!!');
                return false;
            }
            });
        },
    },
    activated(){
        var user = localStorage.getItem('key')
        console.log(user)
        if(user){
            this.$router.push({path:'/home/index'})
        }
    }
}
</script>

<style scoped>
.login-container {
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -moz-border-radius: 5px;
    background-clip: padding-box; 
    width: 460px;    
    padding: 35px 80px 15px 80px;
    background: #fff;
    border: 1px solid #000;
    box-shadow: 0 0 25px #cac6c6;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    /*box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0px 0 rgba(0, 0, 0, 0.02);*/
    /* border: 1px solid #eaeaea; */
    /* padding: 35px 35px 15px 35px; */
    /* margin: 150px auto 90px; */
  }
  .title {
      margin: 0px auto 30px auto;
      text-align: center;
      font-size: 20px;
      font-weight: bold;
      color: #505458;
    }
    .bgimg{       
        background: url('../assets/loginbg.png');
        background-size: 100% 100%;
        height: 100%;
        width: 100%;
        /* position: fixed; */
    }
    a{
        text-decoration: underline;
    }

</style>


// WEBPACK FOOTER //
// src/views/Login.vue